import { render, staticRenderFns } from "./update-prices.vue?vue&type=template&id=1e3f5d1e&"
import script from "./update-prices.vue?vue&type=script&lang=js&"
export * from "./update-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports